// removed by extract-text-webpack-plugin
module.exports = {"video":"nrk-video","darkedout":"nrk-darkedout","fullscreen--video":"nrk-fullscreen--video","fullscreen--video--container":"nrk-fullscreen--video--container","video-mute-button":"nrk-video-mute-button","video-mute-svg-muted-hover":"nrk-video-mute-svg-muted-hover","video-mute-svg-unmuted-hover":"nrk-video-mute-svg-unmuted-hover","visible":"nrk-visible","subtitlescontainer":"nrk-subtitlescontainer","subtitles":"nrk-subtitles"};


//////////////////
// WEBPACK FOOTER
// ./src/shared/stylesheets/video.css
// module id = 4
// module chunks = 0